import * as React from "react";
import { cn } from "../../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
	<input
		ref={ref}
		className={cn(
			"w-full h-8 px-3 bg-[#020907] border border-[#1b4d43] text-[#d8fff7] font-mono text-sm placeholder:text-[#6f9f94] focus:outline-none focus:border-[#00ffcc99] focus:ring-1 focus:ring-[#00ffcc33] transition-colors",
			className,
		)}
		{...props}
	/>
));
Input.displayName = "Input";
